/**
 * @file automatically generated from MApp.Endpoints.DesktopClientContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveOverview, IOverview, IOverviewListItem, IPostSaveLayer, IValidationResult, ISavePrintLayout, IPrintLayoutListItem, IPrintLayout, ISaveQuery, IQuery, IQueryListItem, ITestQuery, ISaveActionSet, IActionSetListItem, IActionSet } from '../models';

export class DesktopClientContentClient extends MetadataClient {

    public static saveOverview(overview: ISaveOverview) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(overview)
			})
        );
    }

    public static deleteOverview(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static replaceOverview(id: string, overview: ISaveOverview) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overiews/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(overview)
			})
        );
    }

    public static getOverview(id: string) {
        return MetadataClient.ajax<IOverview>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/${encodeURIComponent(id)}`)
        );
    }

    public static getOverviews() {
        return MetadataClient.ajax<IOverviewListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews`)
        );
    }

    public static saveLayer(overviewId: string, layer: IPostSaveLayer) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/layers/${encodeURIComponent(overviewId)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layer)
			})
        );
    }

    public static deleteLayer(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/layers/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static reorderOverviewLayers(layerIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/layers/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layerIds)
			})
        );
    }

    public static isValidOverview(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/overviews/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static savePrintLayout(printLayout: ISavePrintLayout) {
        return MetadataClient.ajax<IPrintLayoutListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(printLayout)
			})
        );
    }

    public static updatePrintLayout(id: string, printLayout: ISavePrintLayout) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(printLayout)
			})
        );
    }

    public static deletePrintLayout(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getPrintLayouts() {
        return MetadataClient.ajax<IPrintLayoutListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts`)
        );
    }

    public static getPrintLayout(id: string) {
        return MetadataClient.ajax<IPrintLayout>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts/${encodeURIComponent(id)}`)
        );
    }

    public static isValidPrintLayout(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static saveQuery(query: ISaveQuery) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(query)
			})
        );
    }

    public static updateQuery(id: string, query: ISaveQuery) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(query)
			})
        );
    }

    public static deleteQuery(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getQuery(id: string) {
        return MetadataClient.ajax<IQuery>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries/${encodeURIComponent(id)}`)
        );
    }

    public static getQueries() {
        return MetadataClient.ajax<IQueryListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries`)
        );
    }

    public static isValidQuery(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static testQuery(query: ITestQuery) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/queries/test`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(query)
			})
        );
    }

    public static saveActionSet(actionSet: ISaveActionSet) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(actionSet)
			})
        );
    }

    public static updateActionSet(id: string, actionSet: ISaveActionSet) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(actionSet)
			})
        );
    }

    public static getActionSets() {
        return MetadataClient.ajax<IActionSetListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets`)
        );
    }

    public static getActionSet(id: string) {
        return MetadataClient.ajax<IActionSet>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets/${encodeURIComponent(id)}`)
        );
    }

    public static deleteActionSet(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidActionSet(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/actionsets/isvalid?name=${encodeURIComponent(name)}`)
        );
    }
    
    public static savePrintLayoutBinary(formData: FormData, id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/printlayouts/${encodeURIComponent(id)}/upload`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
}
